import React from "react";
import PropTypes from "prop-types";

const KEY_FIGURE_COMPONENTS = {
    "graph1": "investor-key-figure-graph1",
    "graph2": "investor-key-figure-graph2",
    "graph3": "investor-key-figure-graph3",
    "graph4": "investor-key-figure-graph4",
    "graph5": "investor-key-figure-graph5",
    "graph6": "investor-key-figure-graph6"
};

const AlvKeyFiguresBlockItem = ({ language, heading, componentKey }) => {
    const WebComponentTag = KEY_FIGURE_COMPONENTS[componentKey];
    if (!WebComponentTag) return null;

    return (
        <div className="alv-key-figures-block-item">
            {heading && <h3 className="alv-key-figures-block-item__heading">{heading}</h3>}
            {React.createElement(WebComponentTag, { lang: language, class: "alv-key-figures-block-item__component" })}
        </div>
    );
};

AlvKeyFiguresBlockItem.propTypes = {
    heading: PropTypes.string,
    componentKey: PropTypes.oneOf(Object.keys(KEY_FIGURE_COMPONENTS)).isRequired,
    language: PropTypes.string // FE only
};

export default AlvKeyFiguresBlockItem;



// WEBPACK FOOTER //
// ./src/components/AlvKeyFiguresBlock/AlvKeyFiguresBlockItem.jsx